var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CUSTOMER_ACTIVATE_BY_URL = exports.CUSTOMER_ACTIVATE = exports.CUSTOMER_RESET_BY_URL = exports.CUSTOMER_RESET = exports.CUSTOMER_RECOVER = exports.CUSTOMER_DEFAULT_ADDRESS_UPDATE = exports.CUSTOMER_ADDRESS_UPDATE = exports.CUSTOMER_ADDRESS_DELETE = exports.CUSTOMER_ADDRESS_CREATE = exports.CUSTOMER_UPDATE = exports.CUSTOMER_CREATE = exports.CUSTOMER_ACCESS_TOKEN_CREATE_MULTIPASS = exports.CUSTOMER_ACCESS_TOKEN_CREATE = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const mailingAddressFragment_1 = require("../fragments/mailingAddressFragment");
const customerUserErrorFragment_1 = require("../fragments/customerUserErrorFragment");
exports.CUSTOMER_ACCESS_TOKEN_CREATE = (0, graphql_tag_1.default)`
  mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
    customerAccessTokenCreate(input: $input) {
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        ...CustomerUserErrorFragment
      }
    }
  }
  ${customerUserErrorFragment_1.CUSTOMER_USER_ERROR_FRAGMENT}
`;
exports.CUSTOMER_ACCESS_TOKEN_CREATE_MULTIPASS = (0, graphql_tag_1.default)`
  mutation customerAccessTokenCreateWithMultipass($multipassToken: String!) {
    customerAccessTokenCreateWithMultipass(multipassToken: $multipassToken) {
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        ...CustomerUserErrorFragment
      }
    }
  }
  ${customerUserErrorFragment_1.CUSTOMER_USER_ERROR_FRAGMENT}
`;
exports.CUSTOMER_CREATE = (0, graphql_tag_1.default)`
  mutation customerCreate($input: CustomerCreateInput!) {
    customerCreate(input: $input) {
      customer {
        id
      }
      customerUserErrors {
        ...CustomerUserErrorFragment
      }
    }
  }
  ${customerUserErrorFragment_1.CUSTOMER_USER_ERROR_FRAGMENT}
`;
exports.CUSTOMER_UPDATE = (0, graphql_tag_1.default)`
  mutation customerUpdate($customerAccessToken: String!, $customer: CustomerUpdateInput!) {
    customerUpdate(customerAccessToken: $customerAccessToken, customer: $customer) {
      customer {
        id
      }
      customerUserErrors {
        ...CustomerUserErrorFragment
      }
    }
  }
  ${customerUserErrorFragment_1.CUSTOMER_USER_ERROR_FRAGMENT}
`;
exports.CUSTOMER_ADDRESS_CREATE = (0, graphql_tag_1.default)`
  mutation customerAddressCreate($customerAccessToken: String!, $address: MailingAddressInput!) {
    customerAddressCreate(customerAccessToken: $customerAccessToken, address: $address) {
      customerAddress {
        ...MailingAddressFragment
      }
      customerUserErrors {
        ...CustomerUserErrorFragment
      }
    }
  }
  ${mailingAddressFragment_1.MAILING_ADDRESS_FRAGMENT}
  ${customerUserErrorFragment_1.CUSTOMER_USER_ERROR_FRAGMENT}
`;
exports.CUSTOMER_ADDRESS_DELETE = (0, graphql_tag_1.default)`
  mutation customerAddressDelete($customerAccessToken: String!, $id: ID!) {
    customerAddressDelete(customerAccessToken: $customerAccessToken, id: $id) {
      deletedCustomerAddressId
      customerUserErrors {
        ...CustomerUserErrorFragment
      }
    }
  }
  ${customerUserErrorFragment_1.CUSTOMER_USER_ERROR_FRAGMENT}
`;
exports.CUSTOMER_ADDRESS_UPDATE = (0, graphql_tag_1.default)`
  mutation customerAddressUpdate($customerAccessToken: String!, $id: ID!, $address: MailingAddressInput!) {
    customerAddressUpdate(customerAccessToken: $customerAccessToken, id: $id, address: $address) {
      customerAddress {
        ...MailingAddressFragment
      }
      customerUserErrors {
        ...CustomerUserErrorFragment
      }
    }
  }
  ${mailingAddressFragment_1.MAILING_ADDRESS_FRAGMENT}
  ${customerUserErrorFragment_1.CUSTOMER_USER_ERROR_FRAGMENT}
`;
exports.CUSTOMER_DEFAULT_ADDRESS_UPDATE = (0, graphql_tag_1.default)`
  mutation customerDefaultAddressUpdate($customerAccessToken: String!, $addressId: ID!) {
    customerDefaultAddressUpdate(customerAccessToken: $customerAccessToken, addressId: $addressId) {
      customer {
        id
      }
      customerUserErrors {
        ...CustomerUserErrorFragment
      }
    }
  }
  ${customerUserErrorFragment_1.CUSTOMER_USER_ERROR_FRAGMENT}
`;
exports.CUSTOMER_RECOVER = (0, graphql_tag_1.default)`
  mutation customerRecover($email: String!) {
    customerRecover(email: $email) {
      customerUserErrors {
        ...CustomerUserErrorFragment
      }
    }
  }
  ${customerUserErrorFragment_1.CUSTOMER_USER_ERROR_FRAGMENT}
`;
exports.CUSTOMER_RESET = (0, graphql_tag_1.default)`
  mutation customerReset($id: ID!, $input: CustomerResetInput!) {
    customerReset(id: $id, input: $input) {
      customer {
        id
      }
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        ...CustomerUserErrorFragment
      }
    }
  }
  ${customerUserErrorFragment_1.CUSTOMER_USER_ERROR_FRAGMENT}
`;
exports.CUSTOMER_RESET_BY_URL = (0, graphql_tag_1.default)`
  mutation customerResetByUrl($resetUrl: URL!, $password: String!) {
    customerResetByUrl(resetUrl: $resetUrl, password: $password) {
      customer {
        id
      }
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        ...CustomerUserErrorFragment
      }
    }
  }
  ${customerUserErrorFragment_1.CUSTOMER_USER_ERROR_FRAGMENT}
`;
exports.CUSTOMER_ACTIVATE = (0, graphql_tag_1.default)`
  mutation customerActivate($id: ID!, $input: CustomerActivateInput!) {
    customerActivate(id: $id, input: $input) {
      customer {
        id
      }
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        ...CustomerUserErrorFragment
      }
    }
  }
  ${customerUserErrorFragment_1.CUSTOMER_USER_ERROR_FRAGMENT}
`;
exports.CUSTOMER_ACTIVATE_BY_URL = (0, graphql_tag_1.default)`
  mutation customerActivateByUrl($activationUrl: URL!, $password: String!) {
    customerActivateByUrl(activationUrl: $activationUrl, password: $password) {
      customer {
        id
      }
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        ...CustomerUserErrorFragment
      }
    }
  }
  ${customerUserErrorFragment_1.CUSTOMER_USER_ERROR_FRAGMENT}
`;